"use client";

import type { SbBlokData } from "@storyblok/react/rsc";
import { storyblokEditable } from "@storyblok/react/rsc";

import type { LinkStoryblok } from "@/generated/sb/sb-types";

import { Link } from "@/i18n/routing";
import { getLink } from "@frend-digital/storyblok";
import styles from "./index.module.css";

const MenuItem = (
  link: LinkStoryblok | { component: string; link: undefined; text: string },
) => {
  if (link.component === "divider") {
    return <div className={styles.divider} />;
  }

  const href = getLink(link.link);
  if (!href) {
    return null;
  }
  return (
    <li>
      <Link href={href} className={styles.menuButton}>
        {link.text}
        <div className={styles.underline} />
      </Link>
    </li>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const HeaderBloks = ({ blok }: any) => {
  const { links, secondary } = blok;
  return (
    <nav
      className={styles.menu}
      {...storyblokEditable(blok as unknown as SbBlokData)}
    >
      <ul className={styles.menu__list}>
        {links.map((link: LinkStoryblok) => (
          <MenuItem {...link} key={link._uid} />
        ))}
      </ul>

      <ul className={`${styles.menu__list} ${styles.secondary}`}>
        {secondary.map((link: LinkStoryblok) => (
          <MenuItem {...link} key={link._uid} />
        ))}
      </ul>
    </nav>
  );
};

export default HeaderBloks;
